import Super from '../../core/button.gjs';
import styles from './primary.module.scss';

export default class SpdsActionButtonPrimary extends Super {
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-primary';
  variantStyles = styles;
}
